<section class="bk-panel rg" aria-labelledby="rg-message-title">
  <header class="rg__head">
    <h2 class="bk-eyebrow" id="rg-message-title">Delivery by message</h2>
    <span class="rg__note">Share of each message's sends delivered</span>
  </header>

  @if (rows.length) {
    <div class="rg__canvas" [style.height.px]="height" role="img" [attr.aria-label]="'Delivery rate for ' + rows.length + ' messages'">
      <canvas baseChart [type]="'bar'" [data]="chartData" [options]="chartOptions"></canvas>
    </div>

    <table class="bk-sr-only">
      <caption>Delivery rate by message</caption>
      <tr><th scope="col">Message</th><th scope="col">Delivered</th></tr>
      @for (row of rows; track $index) {
        <tr><td>{{ row.message }}</td><td>{{ row.deliveryRate }}%</td></tr>
      }
    </table>
  } @else {
    <p class="rg__empty">No delivery data by message yet. It appears once receipts come back for a send.</p>
  }
</section>
